export default __webpack_public_path__ + "static/media/circles-no-5.684b96df.ogg";